// extracted by mini-css-extract-plugin
export default {"rightAsideStyle":"RightAside_rightAsideStyle__Nsvck"};